<template>
  <BaseCard
    :heading="$t('dashboard.online_bookings.title')"
    v-test="'dashboard-online-bookings'"
  >
    <div :class="$style.inner">
      <img src="/img/dashboard/online-bookings.svg">
      <BaseButton
        :routerLink="{ name: 'admin-online-bookings' }"
        color="inverted"
        mt
        v-test="'dashboard-online-bookings-link'"
      >
        {{ $t('dashboard.online_bookings.link') }}
      </BaseButton>
    </div>
  </BaseCard>
</template>

<style
  lang="scss"
  module
>
.inner {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
